<template>
    <div>
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Stored Questions</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>

                <v-row justify="center" dense>
                    <v-col cols="12" sm="3" v-if="chapters_list != ''">
                        <p><v-icon color="error">*</v-icon><b>Chapter List</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="chapter" :items="chapters_list"
                            item-text="name" item-value="id" label="Chapter" outlined persistent-hint
                            hint="Please Select Chapter" multiple />
                    </v-col>
                    <v-col cols="12" sm="3" v-if="Level_listAll != null && chapter">

                        <p><v-icon color="error">*</v-icon><b>Difficulty Level List</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="Level" item-value="Level_id"
                            :items="Level_listAll" item-text="Level_name" label="Difficulty Level" outlined multiple />
                    </v-col>
                    <v-col cols="12" sm="1" md="1" align="center" class="pt-4 mt-5">
                        <v-btn class="button" @click="fetchQuestions()" :loading="loader">Fetch</v-btn>
                    </v-col>
                </v-row>
            </v-card>
            <!-- {{sel_crs}} -->

            <v-card class="box" v-if="question_list != ''">
                <v-toolbar flat class="toolbar">
                    <v-toolbar-title>Question List</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>

                <v-row dense justify="center">
                    <v-radio-group inline v-model="view" row>
                        <v-radio label="Non Archived" value="non_archived"></v-radio>
                        <v-radio label="Archived" value="archived"></v-radio>
                        <v-radio label="All" value="all"></v-radio>


                    </v-radio-group>
                </v-row>

                <v-data-table :headers="headers" :items="filteredQuestions" show-select :search="search"
                    class="elevation-1 mytable" v-model="selected" item-key="id" :items-per-page="-1" fixed-header
                    height="600px">
                    <template v-slot:[`item.question`]="{ item }">
                        <span v-html="item.question"> </span>
                    </template>
                    <template v-slot:[`item.filepath`]="{ item }">
                        <v-btn icon @click="viewQuizQuestion(item)"> <v-icon color="black">mdi-eye</v-icon></v-btn>
                    </template>

                    <template v-slot:[`item.is_question_archived`]="{ item }">
                        <span v-if="item.is_question_archived">
                            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                        </span>
                        <span v-else>
                            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                        </span>
                    </template>

                    <template v-slot:top>
                        <v-row>
                            <v-col cols="12" sm="1" md="1"></v-col>

                            <div>
                                <!-- <th> -->
                                <v-row>
                                    <span v-for="header in headers" :key="header.text">
                                        <span v-if="filters.hasOwnProperty(header.value)">
                                            <v-autocomplete class="mr-2 " flat hide-details small rounded dense outlined
                                                color="#0F2027" :label="header.text" multiple clearable
                                                :items="columnValueList(header.value)"
                                                v-model="filters[header.value]"></v-autocomplete>
                                        </span>
                                    </span>
                                </v-row>
                                <!-- </th> -->
                            </div>

                            <v-col cols="12" sm="1" md="1"></v-col>
                            <v-col cols="12" md="4" sm="4">
                                <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                                    hide-details></v-text-field>
                            </v-col>
                        </v-row>
                    </template>
                </v-data-table>
                <v-row justify="center" dense v-if="this.selected.length > 0">
                    <v-col cols="12" sm="2"> </v-col>
                    <v-col cols="12" sm="2">
                        <v-btn class="button" @click="showStudents()">Select Students</v-btn>
                    </v-col>
                </v-row>
                <v-row justify="center" dense v-if="this.selected.length > 0">
                    <strong>Total Selected - {{ selected.length }}</strong>
                </v-row>
            </v-card>

            <v-row justify="center">
                <v-dialog v-model="show_studnts" fullscreen hide-overlay transition="dialog-bottom-transition">
                    <v-card>
                        <v-toolbar class="toolbar">
                            <v-btn icon dark @click="show_studnts = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-toolbar-title>All Students</v-toolbar-title>
                            <v-toolbar-items>
                                <v-btn dark text @click="show_studnts = false">Close</v-btn>
                            </v-toolbar-items>
                            <v-spacer></v-spacer>
                            <v-toolbar-items>
                                <v-btn class="sub-row" dark text @click="publishQuestions()"
                                    :disabled="selected.length > 0 ? false : true"
                                    :loading="publish_loader">Publish</v-btn>
                                <v-btn class="sub-row" dark text>Total Selected - {{ selected_students.length }}</v-btn>
                            </v-toolbar-items>
                        </v-toolbar>
                        <v-card class="box">
                            <v-row class="sub-row" justify="center" dense>
                                <v-col cols="12" xs="12" sm="12" lg="12" md="12">
                                    <v-data-table :headers="headers_students" :items="learners" :search="search"
                                        class="elevation-1" show-select v-model="selected_students" item-key="lid"
                                        :items-per-page="-1"></v-data-table>
                                </v-col>
                            </v-row>
                        </v-card>
                        <v-row justify="center">
                            <v-btn color="warning" @click="publishQuestions()"
                                :disabled="selected.length > 0 ? false : true" :loading="publish_loader">Publish</v-btn>
                        </v-row>
                        <v-row justify="center" dense v-if="this.selected_students.length > 0">
                            <strong>Total Selected - {{ selected_students.length }}</strong>
                        </v-row>
                    </v-card>
                </v-dialog>
            </v-row>
            <v-row justify="center">
                <v-dialog v-model="dialog_view_mcq" persistent max-width="800px">
                    <v-card>
                        <v-toolbar class="toolbar" flat dense>
                            <v-toolbar-title>
                                <h6>
                                    <strong> MCQ Question </strong>
                                </h6>
                            </v-toolbar-title>
                        </v-toolbar>

                        <br />
                        <!-- {{view_question_list}} -->
                        <v-card-text>
                            <v-container>
                                <v-card class="box">
                                    <v-row justify="center">
                                        <span class="text1">
                                            <strong> Marks::{{ view_question_list.quizQuestion_marks }}</strong>
                                        </span>
                                        <v-col cols="12" sm="12" md="12">
                                            <center>
                                                <span class="text1"> <strong> Problem Statement</strong></span>
                                            </center>
                                        </v-col>
                                    </v-row>

                                    <span v-if="view_question_list.filepath != null">
                                        <span class="span-mr" v-if="view_question_list.quizQuestion_text"
                                            v-html="view_question_list.quizQuestion_text"> </span>
                                        <!-- <img
                    class="imgs"
                    :src="basepath + view_question_list.filepath"
                    @click="zooimg(basepath + view_question_list.filepath)"
                  /> -->
                                        <!-- <a class="p-2" :href="basepath +
                              view_question_list.filepath" target="blank">
                      <v-icon color="black">mdi-eye</v-icon>
                      </a> -->

                                        <v-dialog v-model="dialog_view_img" max-width="500px">
                                            <template v-slot:activator="{ on }">
                                                <v-icon color="black" @click="dialog_view_img = true">mdi-eye</v-icon>
                                            </template>
                                            <v-card>
                                                <v-toolbar class="toolbar" flat dense>
                                                    <v-toolbar-title>
                                                        <h6>
                                                            <strong> Images </strong>
                                                        </h6>
                                                    </v-toolbar-title>
                                                </v-toolbar>
                                                <br />
                                                <v-card-text>
                                                    <center>
                                                        <img :src="basepath + view_question_list.filepath"
                                                            style="border: 3px solid black;" alt="Image" width="200px"
                                                            height="200px" />
                                                    </center>
                                                </v-card-text>
                                                <v-card-actions>
                                                    <v-btn color="error" class="justify-center" rounded
                                                        @click="dialog_view_img = false">Close</v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                    </span>
                                    <span v-else v-html="view_question_list.quizQuestion_text"> </span>
                                    <v-col cols="12" sm="12" md="12">
                                        <center>
                                            <span class="text1"> <strong>Options</strong></span>
                                        </center>
                                    </v-col>
                                    <span v-for="option in view_question_list.option_list" :key="option.op_id">
                                        <v-row align="center">
                                            <v-col cols="1">
                                                <input class="radiospace" type="radio" v-if="option.iscorrect"
                                                    :checked="option.op_id" />
                                                <input type="radio" name="opt" class="radiospace" v-else
                                                    v-model="option.op_id" disabled />
                                            </v-col>

                                            <!-- Column for options -->
                                            <v-col cols="9">
                                                <div style="display: flex; align-items: center;">
                                                    <span class="span-mr" v-if="option.mcq_option_file_path == null"
                                                        v-html="option.option_value"></span>
                                                    <span v-else>
                                                        <span class="span-mr" v-if="option.option_value"
                                                            v-html="option.option_value"></span>
                                                    </span>
                                                </div>
                                            </v-col>

                                            <!-- Column for eye icon -->
                                            <v-col cols="2">
                                                <a :href="basepath + option.mcq_option_file_path + option.mcq_filename"
                                                    target="blank" class="p-2">
                                                    <v-icon color="black">mdi-eye</v-icon>
                                                </a>
                                            </v-col>
                                        </v-row>
                                    </span>
                                </v-card>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-row>
                                <v-btn color="error" class="justify-center" rounded
                                    @click="dialog_view_mcq = false">Close</v-btn>
                            </v-row>
                            <br />
                            <br />
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>

            <v-row justify="center">
                <v-dialog v-model="dialog_view_mwa" persistent max-width="800px">
                    <v-card>
                        <v-toolbar class="toolbar" flat dense>
                            <v-toolbar-title>
                                <h6>
                                    <strong> Fill In The Blanks Question </strong>
                                </h6>
                            </v-toolbar-title>
                        </v-toolbar>
                        <br />
                        <!-- {{view_question_list}} -->
                        <v-card-text>
                            <v-container>
                                <v-card class="box">
                                    <v-row justify="center">
                                        <span class="text1">
                                            <strong> Marks::{{ view_question_list.quizQuestion_marks }}</strong>
                                        </span>
                                        <v-col cols="12" sm="12" md="12">
                                            <center>
                                                <span class="text1"> <strong> Problem Statement</strong></span>
                                            </center>
                                        </v-col>
                                    </v-row>
                                    <span v-html="view_question_list.quizQuestion_text"> </span>
                                    <v-col cols="12" sm="12" md="12">
                                        <center>
                                            <span class="text1"> <strong>Answer(s)</strong></span>
                                        </center>
                                    </v-col>
                                    <span v-for="option in view_question_list.option_list" :key="option.op_id">
                                        <v-row>
                                            <input class="radiospace" type="radio" :checked="option.op_id" />
                                            <span class="span-mr" v-html="option.correct_answer"> </span>
                                        </v-row>
                                        <!-- </v-card> -->
                                    </span>
                                </v-card>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-row>
                                <v-btn color="error" class="justify-center" rounded
                                    @click="dialog_view_mwa = false">Close</v-btn>
                            </v-row>
                            <br />
                            <br />
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>

            <v-row justify="center" v-if="dialog_view_mtp">
                <v-dialog v-model="dialog_view_mtp" persistent max-width="1050px">
                    <v-card>
                        <!-- {{view_question_list}}  -->
                        <v-toolbar class="toolbar" flat dense>
                            <v-toolbar-title>
                                <h6>
                                    <strong> Match The Pair Assignment </strong>
                                </h6>
                            </v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-row justify="center">
                                <span class="text1">
                                    <strong> Marks::{{ view_question_list[0].quizQuestion_marks }}</strong>
                                </span>
                                <v-col cols="12" sm="12" md="12">
                                    <center>
                                        <span class="text1">
                                            <strong>
                                                Problem Statement:
                                                <span v-html="view_question_list[0].quizQuestion_text"> </span>
                                            </strong>
                                        </span>
                                    </center>
                                </v-col>
                            </v-row>

                            <span>
                                <v-col class="p-0 m-0" cols="12" sm="12" md="12">
                                    <v-row>
                                        <v-col cols="12" sm="2" md="2"> </v-col>
                                        <v-col cols="12" sm="3" md="3">
                                            <center><b> Question </b></center>
                                        </v-col>
                                        <v-col cols="12" sm="5" md="5">
                                            <center><b> Answer </b></center>
                                        </v-col>
                                        <v-col cols="12" sm="2" md="2">
                                            <center><b> Weightage </b></center>
                                        </v-col>
                                    </v-row>
                                    <v-row class="p-0 m-0" v-for="(option, index) in view_question_list" :key="index">
                                        <span class="p-3">
                                            <strong>Pair {{ index + 1 }} </strong>
                                        </span>
                                        <a class="p-2" :href="basepath + option.filepath" target="blank">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn icon v-if="option.filepath != null" v-bind="attrs" v-on="on">
                                                        <v-icon color="black">mdi-eye</v-icon></v-btn>
                                                </template>
                                                <span> View Question file!!! </span>
                                            </v-tooltip>
                                        </a>
                                        <v-col class="border1" cols="12" sm="4" md="4">
                                            <span v-html="option.question"></span>
                                        </v-col>

                                        <a class="p-2" :href="basepath + option.mtf_ans_filepath" target="blank">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn icon v-if="option.mtf_ans_filepath != null" v-bind="attrs"
                                                        v-on="on"> <v-icon color="black">mdi-eye</v-icon></v-btn>
                                                </template>
                                                <span> View Answer file!!! </span>
                                            </v-tooltip>
                                        </a>
                                        <v-col class="border1" cols="12" sm="4" md="4">
                                            <span v-html="option.option_name"></span>
                                        </v-col>
                                        <v-col class="border1" cols="12" sm="1" md="1">
                                            <center>{{ option.mtf_marks }}</center>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </span>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-row>
                                <v-btn color="error" class="justify-center" rounded
                                    @click="dialog_view_mtp = false">Close</v-btn>
                            </v-row>
                            <br />
                            <br />
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
            <v-row justify="center">
                <v-dialog v-model="dialog_view_swa" persistent max-width="800px">
                    <v-card>
                        <v-toolbar class="toolbar" flat dense>
                            <v-toolbar-title>
                                <h6>
                                    <strong> Single Word Answer Question </strong>
                                </h6>
                            </v-toolbar-title>
                        </v-toolbar>
                        <br />
                        <!-- {{view_question_list}} -->
                        <v-card-text>
                            <v-container>
                                <v-card class="box">
                                    <v-row justify="center">
                                        <span class="text1">
                                            <strong> Marks::{{ view_question_list.quizQuestion_marks }}</strong>
                                        </span>
                                        <v-col cols="12" sm="12" md="12">
                                            <center>
                                                <span class="text1"> <strong> Problem Statement</strong></span>
                                            </center>
                                        </v-col>
                                    </v-row>
                                    <span v-if="view_question_list.filepath != null">
                                        <span class="span-mr" v-if="view_question_list.quizQuestion_text"
                                            v-html="view_question_list.quizQuestion_text"> </span>
                                        <!-- <img
                    class="imgs"
                    :src="basepath + view_question_list.filepath"
                    @click="zooimg(basepath + view_question_list.filepath)"
                  /> -->
                                        <v-dialog v-model="dialog_view_img" max-width="500px">
                                            <template v-slot:activator="{ on }">
                                                <v-icon color="black" @click="dialog_view_img = true">mdi-eye</v-icon>
                                            </template>
                                            <v-card>
                                                <v-toolbar class="toolbar" flat dense>
                                                    <v-toolbar-title>
                                                        <h6>
                                                            <strong> Images </strong>
                                                        </h6>
                                                    </v-toolbar-title>
                                                </v-toolbar>
                                                <br />
                                                <v-card-text>
                                                    <center>
                                                        <img :src="basepath + view_question_list.filepath"
                                                            style="border: 3px solid black;" alt="Image" width="200px"
                                                            height="200px" />
                                                    </center>
                                                </v-card-text>
                                                <v-card-actions>
                                                    <v-btn color="error" class="justify-center" rounded
                                                        @click="dialog_view_img = false">Close</v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                    </span>
                                    <span v-else v-html="view_question_list.quizQuestion_text"></span>
                                    <!-- <span v-html="view_question_list.quizQuestion_text"> -->
                                    <v-col cols="12" sm="12" md="12">
                                        <center>
                                            <span class="text1"> <strong>Answer(s)</strong></span>
                                        </center>
                                    </v-col>
                                    <span v-for="option in view_question_list.option_list" :key="option.op_id">
                                        <v-row>
                                            <input class="radiospace" type="radio" :checked="option.op_id" />
                                            <span class="span-mr" v-html="option.correct_answer"> </span>
                                        </v-row>
                                        <!-- </v-card> -->
                                    </span>
                                </v-card>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-row>
                                <v-btn color="error" class="justify-center" rounded
                                    @click="dialog_view_swa = false">Close</v-btn>
                            </v-row>
                            <br />
                            <br />
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>

            <v-row justify="center">
                <v-dialog v-model="dialog_view_subj" persistent max-width="800px">
                    <v-card>
                        <v-toolbar class="toolbar" flat dense>
                            <v-toolbar-title>
                                <h6>
                                    <strong> Subjective Question </strong>
                                </h6>
                            </v-toolbar-title>
                        </v-toolbar>

                        <br />
                        <!-- {{view_question_list}} -->
                        <v-card-text>
                            <v-container>
                                <v-card class="box">
                                    <v-row justify="center">
                                        <span class="text1">
                                            <strong> Marks::{{ view_question_list.quizQuestion_marks }}</strong>
                                        </span>
                                        <v-col cols="12" sm="12" md="12">
                                            <center>
                                                <span class="text1"> <strong> Problem Statement</strong></span>
                                            </center>
                                        </v-col>
                                    </v-row>

                                    <span v-if="view_question_list.filepath != null">
                                        <span class="span-mr" v-if="view_question_list.quizQuestion_text"
                                            v-html="view_question_list.quizQuestion_text"> </span>
                                        <!-- <img
                    class="imgs"
                    :src="basepath + view_question_list.filepath"
                    @click="zooimg(basepath + view_question_list.filepath)"
                  /> -->
                                        <v-dialog v-model="dialog_view_img" max-width="500px">
                                            <template v-slot:activator="{ on }">
                                                <v-icon color="black" @click="dialog_view_img = true">mdi-eye</v-icon>
                                            </template>
                                            <v-card>
                                                <v-toolbar class="toolbar" flat dense>
                                                    <v-toolbar-title>
                                                        <h6>
                                                            <strong> Images </strong>
                                                        </h6>
                                                    </v-toolbar-title>
                                                </v-toolbar>
                                                <br />
                                                <v-card-text>
                                                    <center>
                                                        <img :src="basepath + view_question_list.filepath"
                                                            style="border: 3px solid black;" alt="Image" width="200px"
                                                            height="200px" />
                                                    </center>
                                                </v-card-text>
                                                <v-card-actions>
                                                    <v-btn color="error" class="justify-center" rounded
                                                        @click="dialog_view_img = false">Close</v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                    </span>
                                    <span v-else v-html="view_question_list.quizQuestion_text"> </span>
                                    <v-row dense justify="center">
                                        <v-col cols="12" sm="12" md="12">
                                            <center>
                                                <span class="text1"> <strong> Correct / Model Answer</strong></span>
                                            </center>
                                            <span v-html="view_question_list.subjective_correct_answer"> </span>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-row>
                                <v-btn color="error" class="justify-center" rounded
                                    @click="dialog_view_subj = false">Close</v-btn>
                            </v-row>
                            <br />
                            <br />
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
            <v-row justify="center">
                <v-dialog v-model="dialog_view_tof" persistent max-width="800px">
                    <v-card>
                        <v-toolbar class="toolbar" flat dense>
                            <v-toolbar-title>
                                <h6>
                                    <strong> True Or False Question </strong>
                                </h6>
                            </v-toolbar-title>
                        </v-toolbar>

                        <br />
                        <!-- {{view_question_list}} -->
                        <v-card-text>
                            <v-container>
                                <v-card class="box">
                                    <v-row justify="center">
                                        <span class="text1">
                                            <strong> Marks::{{ view_question_list.quizQuestion_marks }}</strong>
                                        </span>
                                        <v-col cols="12" sm="12" md="12">
                                            <center>
                                                <span class="text1"> <strong> Problem Statement</strong></span>
                                            </center>
                                        </v-col>
                                    </v-row>

                                    <span v-if="view_question_list.filepath != null">
                                        <span class="span-mr" v-if="view_question_list.quizQuestion_text"
                                            v-html="view_question_list.quizQuestion_text"> </span>
                                        <!-- <img
                    class="imgs"
                    :src="basepath + view_question_list.filepath"
                    @click="zooimg(basepath + view_question_list.filepath)"
                  /> -->
                                        <v-dialog v-model="dialog_view_img" max-width="500px">
                                            <template v-slot:activator="{ on }">
                                                <v-icon color="black" @click="dialog_view_img = true">mdi-eye</v-icon>
                                            </template>
                                            <v-card>
                                                <v-toolbar class="toolbar" flat dense>
                                                    <v-toolbar-title>
                                                        <h6>
                                                            <strong> Images </strong>
                                                        </h6>
                                                    </v-toolbar-title>
                                                </v-toolbar>
                                                <br />
                                                <v-card-text>
                                                    <center>
                                                        <img :src="basepath + view_question_list.filepath"
                                                            style="border: 3px solid black;" alt="Image" width="200px"
                                                            height="200px" />
                                                    </center>
                                                </v-card-text>
                                                <v-card-actions>
                                                    <v-btn color="error" class="justify-center" rounded
                                                        @click="dialog_view_img = false">Close</v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                    </span>
                                    <span v-else v-html="view_question_list.quizQuestion_text"> </span>
                                    <v-col cols="12" sm="12" md="12">
                                        <center>
                                            <span class="text1"> <strong>Options</strong></span>
                                        </center>
                                    </v-col>
                                    <span v-for="option in view_question_list.option_list" :key="option.op_id">
                                        <v-row align="center">
                                            <v-col cols="1">
                                                <input class="radiospace" type="radio" v-if="option.iscorrect"
                                                    :checked="option.op_id" />
                                                <input type="radio" name="opt" class="radiospace" v-else
                                                    v-model="option.op_id" disabled />
                                            </v-col>

                                            <!-- Column for options -->
                                            <v-col cols="9">
                                                <div style="display: flex; align-items: center;">
                                                    <span class="span-mr" v-if="option.mcq_option_file_path == null"
                                                        v-html="option.option_value"></span>
                                                    <span v-else>
                                                        <span class="span-mr" v-if="option.option_value"
                                                            v-html="option.option_value"></span>
                                                    </span>
                                                </div>
                                            </v-col>

                                            <!-- Column for eye icon -->
                                            <v-col cols="2">
                                                <a :href="basepath + option.mcq_option_file_path + option.mcq_filename"
                                                    target="blank" class="p-2">
                                                    <v-icon color="black">mdi-eye</v-icon>
                                                </a>
                                            </v-col>
                                        </v-row>
                                    </span>
                                </v-card>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-row>
                                <v-btn color="error" class="justify-center" rounded
                                    @click="dialog_view_tof = false">Close</v-btn>
                            </v-row>
                            <br />
                            <br />
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        </v-container>
    </div>
    <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    props: {
        Level_listAll: String,
        sel_crs: Array,
    },
    data: () => ({
        view: null,
        chapters_list: [],
        loader: false,
        publish_loader: false,
        snackbar_msg: "",
        Level: "",
        color: "",
        snackbar: false,
        overlay: false,
        title: "",
        description: "",
        headers: [
            { text: "Sr No", value: "srno" },
            { text: "Quiz Type", value: "quiztype" },
            { text: "Question", value: "question" },
            { text: "Archived", value: "is_question_archived" },
            { text: "chapter", value: "chapter" },
            { text: "Level", value: "quizquestiondifficultylevel" },
            { text: "Marks", value: "marks" },
            { text: "View", value: "filepath" },
        ],
        chapter: "",
        question_list: [],
        selected: [],
        total_selected: [],
        coi_ids: [],
        coff_id: [],
        headers_students: [
            { text: "Sr. No.", value: "count", sortable: "true" },
            { text: "Student", value: "name" },
        ],
        learners: [],
        show_studnts: false,
        search: null,
        total_students: [],
        selected_students: [],
        view_question_list: [],
        dialog_view_img: false,
        dialog_view_mcq: false,
        dialog_view_mwa: false,
        dialog_view_mtp: false,
        dialog_view_swa: false,
        dialog_view_subj: false,
        basepath: null,
        filterArr: [],
        filters: {
            quiztype: [],
        },
        dialog_view_tof: false,
    }),
    methods: {
        filteredQuestions() {
            if (this.view === 'all') {
                return this.question_list;
            } else if (this.view === 'archived') {
                return this.question_list.filter(question => question.is_question_archived);
            } else if (this.view === 'non_archived') {
                return this.question_list.filter(question => !question.is_question_archived);
            }
        },
        getFiltered(e) {
            this.filterArr = e;
        },
        columnValueList(val) {
            console.log("in col fin", val);
            return this.question_list.map((d) => d[val]);
        },
        async viewQuizQuestion(item) {
            const data = {
                qid: item.id,
                from: "View_Bank",
            };
            try {
                const res = await axios.post("/LiveClass/viewQuestion", data);
                if (res.data.flag == "YES") {
                    if (res.data.quiztype == "MCQ") {
                        this.dialog_view_mcq = true;
                        this.view_question_list = res.data.questions[0];
                    }
                    if (res.data.quiztype == "MultiWordAnswer") {
                        this.dialog_view_mwa = true;
                        this.view_question_list = res.data.questions[0];
                    }
                    if (res.data.quiztype == "SWA") {
                        this.dialog_view_swa = true;
                        this.view_question_list = res.data.questions[0];
                    }
                    if (res.data.quiztype == "MTP") {
                        this.dialog_view_mtp = true;
                        this.view_question_list = res.data.questions[0];
                    }
                    if (res.data.quiztype == "SUBJECTIVE") {
                        this.dialog_view_subj = true;
                        this.view_question_list = res.data.questions[0];
                    }
                    if (res.data.quiztype == "TrueFalse") {
                        this.dialog_view_tof = true;
                        this.view_question_list = res.data.questions[0];
                    }
                }
                if (res.data.flag == "No") {
                    this.showSnackbar("red", res.data.snackbar); // show snackbar
                }
            } catch (error) {
                this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            } finally {
            }
        },
        async call() {
            const formdata = {
                sel_crs: this.sel_crs,
            };
            this.overlay = true;
            try {
                const res = await axios.post("/liveClass/getQuestions", formdata);
                if (res.data.flag == "YES") {
                    this.chapters_list = res.data.chaptersAll;
                    if (this.chapters_list == "" || this.chapters_list == null) {
                        this.showSnackbar("red", "Chapters Not Added...Please Add Chapters...");
                        return;
                    }
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.overlay = false;
            } catch (err) {
                console.log("err", err);
                this.onerror(err);
                this.overlay = false;
            } finally {
                console.log("bye...");
                this.overlay = false;
            }
        },
        markAllSelected() {
            this.selected_students = [];
            for (let i = 0; i < this.learners.length; i++) {
                this.selected_students.push(this.learners[i]);
            }
        },
        showStudents() {
            this.show_studnts = true;
            this.markAllSelected();
        },
        async publishQuestions() {
            this.total_selected = [];
            this.coi_ids = [];
            for (var i = 0; i < this.selected.length; i++) {
                this.total_selected.push(this.selected[i].id);
            }
            for (var i = 0; i < this.sel_crs.length; i++) {
                this.coi_ids.push(this.sel_crs[i].coi_id);
            }
            if (this.total_selected.length <= 0) {
                this.showSnackbar("#b71c1c", "Please select Questions!"); // show snackbar
            }

            for (var i = 0; i < this.selected_students.length; i++) {
                this.total_students.push(this.selected_students[i].lid);
                // formData.append("total_students", this.selected[i].lid);
            }
            if (this.total_students.length <= 0) {
                this.showSnackbar("#b71c1c", "Please select Students!"); // show snackbar
            }
            this.publish_loader = true;
            const data = {
                questions: this.total_selected,
                coi_ids: this.coi_ids,
                total_students: this.total_students,
            };
            try {
                const res = await axios.post("/LiveClass/publishQuestions", data);
                if (res.data.flag == "YES") {
                    //this.question_list=res.data.question_list
                    this.showSnackbar("green", "Questions Published Successfully..."); // show snackbar
                    (this.total_students = []), (this.show_studnts = false);
                    (this.total_selected = []), (this.selected_students = []);
                    this.publish_loader = false;
                }
                if (res.data.flag == "No") {
                    this.showSnackbar("red", res.data.snackbar); // show snackbar
                }
            } catch (error) {
                this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            } finally {
                this.publish_loader = false;
            }
        },
        async fetchQuestions() {
            this.coff_id = [];
            for (var i = 0; i < this.sel_crs.length; i++) {
                this.coff_id.push(this.sel_crs[i].coff_id);
            }
            const data = {
                chapter: this.chapter,
                coff_id: this.coff_id,
                diffi_level_id: this.Level,
            };
            try {
                const res = await axios.post("/LiveClass/getQuestionBank", data);
                if (res.data.flag == "YES") {
                    this.question_list = res.data.question_list;
                    //this.showSnackbar("green", "Updated Successfully..."); // show snackbar
                }
                if (res.data.flag == "No") {
                    this.showSnackbar("red", res.data.snackbar); // show snackbar
                }
            } catch (error) {
                this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            } finally {
                this.save_loader = false;
            }
        },
        async onLoad() {
            try {
                const res = await axios.post("/LiveClass/getQuestionBank");
                if (res.data.flag == "YES") {
                    this.employee_list = res.data.employee_list;
                }
            } catch (error) {
                this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            } finally {
                //this.save_loader = false;
            }
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    mounted() {
        //alert("sel_crs"+this.sel_crs)
        this.call();
        this.learners = JSON.parse(localStorage.getItem("live-session-students"));
        this.basepath = localStorage.getItem("awspath");
        this.view = 'non_archived'
    },
    watch: {},
    computed: {
        filteredQuestions() {
            return this.bookList1.filter((d) => {
                return this.view === 'all' || (this.view === 'archived' && d.is_question_archived) || (this.view === 'non_archived' && !d.is_question_archived);
            });
        },
        bookList1() {
            return this.question_list.filter((d) => {
                return Object.keys(this.filters).every((f) => {
                    return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                });
            });
        }
    },
};
</script>
<style scoped>
a {
    text-decoration: none;
}

tr,
td,
th {
    border: 1px solid #ccc;
    text-align: center;
}

tr,
tbody {
    border-bottom: 1px solid #ccc;
    border: 1px solid #ccc;
}

td {
    margin: 0.3rem !important;
    padding: 0.4rem !important;
}

@media (min-width: 320px) {

    td,
    th {
        display: table-cell !important;
    }

    td+td,
    th+th {
        width: auto;
    }
}

v-simple-table {
    white-space: nowrap !important;
    text-align: center;
}

.slide {
    color: red;
    font-weight: bold;
    margin-left: 10px;
}

.radiospace {
    margin: 0.5rem !important;
    padding: 0%;
    margin-top: -2rem;
}

.tbhead {
    font-weight: 900;
    font-size: 15px;
    color: red;
}

.button {
    border: 2px solid #424093 !important;
    color: #424093;
    background: transparent !important;
    border-radius: 50px;
    margin: 0.5rem !important;
}

.button:hover {
    color: white;
    background: #424093 !important;
}

.toolbar {
    background-color: #ffb500 !important;
    color: #ffffff !important;
}

.btn-submit:hover {
    background-color: #ffb500 !important;
    color: #ffffff !important;
}

.radiospace {
    margin: 1rem !important;
}

.span-mr {
    margin: 0.7rem !important;
}

.imgs {
    border: 1px solid #ddd;
    border-radius: 4px;
    width: 150px;
    cursor: zoom-in;
}

.imgs-preview {
    border: 1px solid #ddd;
    border-radius: 4px;
    width: auto;
}

.msg {
    color: red;
}

.slide {
    color: red;
    font-weight: bold;
    margin-left: 10px;
}

.name {
    color: #ffb500;
    font-weight: bold;
    letter-spacing: 1px;
}

v-chip {
    width: auto;
}

.text1 {
    color: darkblue !important;
    margin-left: 40px;
}

.textq {
    color: rgb(24, 155, 68) !important;
    margin-left: 40px;
}

.textd {
    color: rgb(168, 173, 196) !important;
    margin-left: 40px;
}

.textg {
    color: #ffb500 !important;
    margin-left: 40px;
}

.box {
    background-color: #add8e630;
    margin: 8px !important;
    padding: 8px;
    border: 2px solid rgb(195, 214, 218) !important;
    border-radius: 10px;
}

.card-border1 {
    margin: 8px !important;
    padding: 8px;
    border: 2px solid white !important;
    border-radius: 10px;
}

.marks {
    text-align: center;
}

.card-border {
    border: 2px solid #424093;
    border-radius: 1px;
    padding: 5px;
    margin: 1rem !important;
    width: auto;
}

.border {
    border: 2px solid gray;
    padding: 10px;
    margin: 10px;
}

.border1 {
    border: 1px solid black;
    padding: 5px;
    margin: 10px;
}

.text-color {
    color: darkblue;
}
</style>
